<template>
    <content-layout>
        <template #header>Collections</template>
        <template #description>The collection tiles on the website's home page. Drag to change their order.</template>
        <template #header-right>
            <el-button type="primary" icon="el-icon-plus" @click="showNewCollection = !showNewCollection">Add collection</el-button>
        </template>

        <div v-if="showNewCollection" class="new-collection">
            <h2 class="section-title">New collection</h2>
            <el-form :model="newCollection" label-position="top">
                <div class="form-grid">
                    <el-form-item label="Title">
                        <el-input v-model="newCollection.title" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="Subtitle">
                        <el-input v-model="newCollection.subtitle" placeholder=""></el-input>
                    </el-form-item>
                </div>
                <el-form-item label="Link">
                    <el-input v-model="newCollection.link" placeholder="/locations?..."></el-input>
                </el-form-item>
                <el-form-item label="Image">
                    <el-upload
                            ref="newImageUpload"
                            :action="rootpath +'/api/image'"
                            :headers="headers"
                            name="image"
                            list-type="picture-card"
                            :multiple="false"
                            :limit="1"
                            :on-success="createCollection"
                            :auto-upload="false">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <div class="form-actions">
                    <el-button type="primary" @click="createCollection">Create</el-button>
                    <el-button @click="showNewCollection = false">Cancel</el-button>
                </div>
            </el-form>
        </div>

        <el-collapse v-model="activeAccordions">
            <draggable v-model="collections" @start="" @end="orderChange">
            <el-collapse-item v-for="(collection, i) in collections" :key="collection._id" :name="i">
                <template slot="title">
                    <i class="el-icon-rank item-list__handle collection-handle"></i>
                    <img v-if="collection.image" :src="$imgix(collection.image, 80)" class="item-list__thumb collection-thumb" alt="">
                    <span>{{ collection.title }}</span>
                    <span v-if="collection.subtitle" class="item-list__meta collection-subtitle">{{ collection.subtitle }}</span>
                </template>
                <el-form :model="collection" label-position="top">
                    <div class="form-grid">
                        <el-form-item label="Title">
                            <el-input v-model="collection.title" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="Subtitle">
                            <el-input v-model="collection.subtitle" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="Link">
                        <el-input v-model="collection.link" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="Image">
                        <el-upload
                                :ref="collection._id"
                                :action="rootpath +'/api/image'"
                                :headers="headers"
                                name="image"
                                :file-list="collection.image !== '' ? [{name: collection.image, url: $imgix(collection.image, 200)}] : []"
                                list-type="picture-card"
                                :multiple="false"
                                :limit="1"
                                :on-success="(response, file, fileList) => {saveCollectionWithNewImage(collection, response, file, fileList)}"
                                :before-remove="confirmRemoveImage"
                                :on-remove="(file, fileList) => { deleteImage(collection) }">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <div class="form-actions">
                        <el-button type="primary" @click="saveCollection(collection)">Save</el-button>
                        <el-button class="form-actions__right" type="danger" plain icon="el-icon-delete"
                                   @click="confirmDeleteCollection(collection)">Delete</el-button>
                    </div>
                </el-form>
            </el-collapse-item>
            </draggable>
        </el-collapse>
    </content-layout>
</template>

<script>
    export default {
        name: "Collections",

        data () {
            return {
                sectionDrawer: false,
                activeAccordions: [],
                collections: [],
                newCollection: {},
                showNewCollection: false,

                rootpath: process.env.VUE_APP_ROOT_API,
                headers: {
                    Authorization: localStorage.getItem('Authorization')
                },
            }
        },

        beforeMount() {
            this.getAllCollections();
        },

        methods: {
            // For when the order changes
            async orderChange () {
                for(let i = 0; i < this.collections.length; i++){
                    let oldOrder = this.collections[i].order;
                    this.collections[i].order = i + 1;

                    await this.axios.patch(`${this.rootpath}/api/collections/${this.collections[i]._id}`, this.collections[i], { headers: this.headers});

                }
                this.getAllCollections();
                this.$notify({title: 'Success', message: 'Order Updated.', type: 'success'});
            },

            getAllCollections () {
                this.axios.get(`${this.rootpath}/api/collections`)
                    .then(response => {
                        this.collections = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            createCollection (response, file, fileList) {
                // If called from submit button, upload image else if called from image upload, save collection.
                if(!file) {
                    this.$refs.newImageUpload.submit();
                } else {
                    this.newCollection.image = response.fileName;
                    this.newCollection.order = this.collections.length + 1;
                    this.axios.post(`${this.rootpath}/api/collections`,
                        this.newCollection, { headers: this.headers})
                        .then(response => {
                            this.getAllCollections();
                            this.newCollection = {};
                            // this.$refs.newImageUpload.fileList = [];
                            this.$refs.newImageUpload.clearFiles();
                            this.$notify({title: 'Success', message: 'Collection Created.', type: 'success'});
                            // Close all accordions
                            this.activeAccordions = [];
                            this.showNewCollection = false;
                        })
                        .catch(error => {
                            this.$notify({title: 'Error', message: error});
                        });
                }
            },
            saveCollection (collection) {
            //    If collection has an image already then save it.
                if(collection.image !== ''){
                    this.axios.patch(`${this.rootpath}/api/collections/${collection._id}`, collection, { headers: this.headers}).then(response => {
                        this.$notify({title: 'Success', message: 'Collection Updated.', type: 'success'});
                        // Close all accordions
                        this.activeAccordions = [];
                        this.getAllCollections();
                    }).catch(error => {
                        this.$notify({title: 'Error', message: error});
                    });
                } else {
                    this.$notify({title: 'Error', message: 'A collection must have an image. '});
                }
            },
            confirmDeleteCollection (collection) {
                this.$confirm(`Delete the "${collection.title}" collection from the home page?`, 'Delete collection', {
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => this.deleteCollection(collection)).catch(() => {});
            },
            confirmRemoveImage () {
                return this.$confirm('Remove this image? A collection needs an image before it can be saved again.', 'Remove image', {
                    confirmButtonText: 'Remove',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                });
            },
            deleteCollection (collection) {
                // Delete Image if it has one
                if(collection.image !== '') {
                    this.axios.delete(`${this.rootpath}/api/image/${collection.image}`, {headers: this.headers})
                        .then(response => {
                            return this.axios.delete(`${this.rootpath}/api/collections/${collection._id}`, { headers: this.headers});
                        })
                        .then(response => {
                            this.$notify({title: 'Success', message: 'Collection Deleted.', type: 'success'});
                            // Close all accordions
                            this.activeAccordions = [];
                            this.getAllCollections();
                         }).catch(err => {
                            this.$notify({title: 'Error', message: err});
                        });
                } else {
                    this.axios.delete(`${this.rootpath}/api/collections/${collection._id}`, { headers: this.headers})
                        .then(response => {
                            this.$notify({title: 'Success', message: 'Collection Deleted.', type: 'success'});
                            // Close all accordions
                            this.activeAccordions = [];
                            this.getAllCollections();
                        })
                        .catch(err => {
                            this.$notify({title: 'Error', message: err});
                        });
                }
            },

            deleteImage (collection) {
            //    First delete the image
                this.axios.delete(`${this.rootpath}/api/image/${collection.image}`, {headers: this.headers}).then(response => {
                    // Then delete it from the object.
                    collection.image = '';
                    console.log(collection);
                    // Patch the collection
                    return this.axios.patch(`${this.rootpath}/api/collections/${collection._id}`, collection, { headers: this.headers});
                }).then(response=> {
                    this.getAllCollections();
                    this.$notify({title: 'Success', message: 'Collection Image Deleted.', type: 'success'});
                }).catch(err => {
                    this.$notify({title: 'Error', message: err});
                });

            },

            saveCollectionWithNewImage(collection, response, file, fileList) {
                collection.image = response.fileName;
                this.axios.patch(`${this.rootpath}/api/collections/${collection._id}`, collection, { headers: this.headers}).then(response => {
                    this.$notify({title: 'Success', message: 'Collection Image Updated.', type: 'success'});
                    // Close all accordions
                    this.activeAccordions = [];
                    this.getAllCollections();
                }).catch(error => {
                    this.$notify({title: 'Error', message: error});
                });

            }
        }
    }
</script>

<style scoped>
    .new-collection {
        max-width: 820px;
        margin-bottom: 24px;
        padding: 20px 24px 24px;
        border: 1px solid var(--lav-green);
        border-radius: var(--radius);
        background: #fbfefd;
    }

    .form-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: 24px;
    }

    .collection-handle {
        margin-right: 10px;
    }

    .collection-thumb {
        margin-right: 12px;
    }

    .collection-subtitle {
        margin-left: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/site-content/Collections.vue